export const environment = {
  production: false,
  enableGTM: false,
  serviceApiUrl: 'https://stage-service.learn.mlieducation.org/api/v1',
  uiUrl: 'https://stage-ui.learn.mlieducation.org/',
  npiApiUrl: 'https://service.npi.mlieducation.org/api/',
  npiApiKey: '74255a10-bcd3-11f1-918b-956ba3f04dd7',
  npiApiToken: '84825890-fdcc-11ef-9eb4',
  resetPasswordPageUrl: 'https://stage-ui.learn.mlieducation.org/auth/reset-password',
  reverb: {
    key: 'hdipc2eus4vx8qzh9mdl',
    host: 'stage-service.learn.mlieducation.org',
    port: 443,
    scheme: 'https',
  },
};
